module.exports = __webpack_public_path__ + "img/daskipper.c2532a6b.png";